import React, { FC } from 'react';

import { UseInvisibleCaptcha } from './use-invisible-captcha';

type InvisibleCaptchaProps = Readonly<ReturnType<UseInvisibleCaptcha>> &
    Readonly<{ className?: string | undefined }>;
export const InvisibleCaptcha: FC<InvisibleCaptchaProps> = (props) => {
    const { captchaRootRef, className } = props;
    return <div ref={captchaRootRef} className={className} />;
};
